import _Reflect$construct from "@babel/runtime-corejs3/core-js-stable/reflect/construct";
import _Object$getOwnPropertySymbols from "@babel/runtime-corejs3/core-js-stable/object/get-own-property-symbols";
import _filterInstanceProperty from "@babel/runtime-corejs3/core-js-stable/instance/filter";
import _Object$getOwnPropertyDescriptor from "@babel/runtime-corejs3/core-js-stable/object/get-own-property-descriptor";
import _Object$getOwnPropertyDescriptors from "@babel/runtime-corejs3/core-js-stable/object/get-own-property-descriptors";
import _Object$defineProperties from "@babel/runtime-corejs3/core-js-stable/object/define-properties";
import _Object$defineProperty from "@babel/runtime-corejs3/core-js-stable/object/define-property";
import _classCallCheck from "@babel/runtime-corejs3/helpers/classCallCheck";
import _createClass from "@babel/runtime-corejs3/helpers/createClass";
import _assertThisInitialized from "@babel/runtime-corejs3/helpers/assertThisInitialized";
import _inherits from "@babel/runtime-corejs3/helpers/inherits";
import _possibleConstructorReturn from "@babel/runtime-corejs3/helpers/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime-corejs3/helpers/getPrototypeOf";
import _defineProperty from "@babel/runtime-corejs3/helpers/defineProperty";

function ownKeys(object, enumerableOnly) { var keys = _Object$keys(object); if (_Object$getOwnPropertySymbols) { var symbols = _Object$getOwnPropertySymbols(object); if (enumerableOnly) { symbols = _filterInstanceProperty(symbols).call(symbols, function (sym) { return _Object$getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { var _context7; _forEachInstanceProperty(_context7 = ownKeys(Object(source), true)).call(_context7, function (key) { _defineProperty(target, key, source[key]); }); } else if (_Object$getOwnPropertyDescriptors) { _Object$defineProperties(target, _Object$getOwnPropertyDescriptors(source)); } else { var _context8; _forEachInstanceProperty(_context8 = ownKeys(Object(source))).call(_context8, function (key) { _Object$defineProperty(target, key, _Object$getOwnPropertyDescriptor(source, key)); }); } } return target; }

import _concatInstanceProperty from "@babel/runtime-corejs3/core-js-stable/instance/concat";
import _includesInstanceProperty from "@babel/runtime-corejs3/core-js-stable/instance/includes";
import _forEachInstanceProperty from "@babel/runtime-corejs3/core-js-stable/instance/for-each";
import _Object$keys from "@babel/runtime-corejs3/core-js-stable/object/keys";
import _reduceInstanceProperty from "@babel/runtime-corejs3/core-js-stable/instance/reduce";
import _Promise from "@babel/runtime-corejs3/core-js-stable/promise";
import _mapInstanceProperty from "@babel/runtime-corejs3/core-js-stable/instance/map";

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = _Reflect$construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !_Reflect$construct) return false; if (_Reflect$construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(_Reflect$construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

import React, { Component } from 'react';
import { connect } from 'react-redux';
import { STATUS_IDLE, STATUS_LOADING, STATUS_LOADED } from '@rexlabs/entity-normalizer';
import _ from 'lodash';
import uuid from '../../utils/uuid';
import { getDisplayName } from '../../utils/react';
import { autobind } from 'core-decorators';
import { __DEV__ } from '../../utils/env';
import { mapEntityDispatch, mapEntityListState } from './map';
import { filterDataToFields } from '../../utils/queries';
/**
 * HoC that wraps any React component and loads given entity list either
 * from redux store if available or from API
 * @param  {Object} model
 * @param  {string} id
 * @param  {Object} args
 * @param  {string} namespace
 * @return {Function}
 */

export default function withEntityList(model) {
  // The following is for backwards compability
  var options = (arguments.length <= 1 ? undefined : arguments[1]) === undefined ? {} : arguments.length <= 1 ? undefined : arguments[1];

  if ((arguments.length <= 1 ? 0 : arguments.length - 1) > 1 || !_.isObject(options)) {
    if (__DEV__) {
      console.warn('Not using an object as argument for `withEntityList` is deprecated and might not be supported in future versions!');
    }

    options = {
      id: arguments.length <= 1 ? undefined : arguments[1],
      args: arguments.length <= 2 ? undefined : arguments[2],
      namespace: arguments.length <= 3 ? undefined : arguments[3],
      autoload: arguments.length <= 4 ? undefined : arguments[4],
      fields: arguments.length <= 5 ? undefined : arguments[5]
    };
  }

  var _options = options,
      _options$id = _options.id,
      id = _options$id === void 0 ? uuid() : _options$id,
      _options$args = _options.args,
      args = _options$args === void 0 ? {} : _options$args,
      namespace = _options.namespace,
      _options$autoload = _options.autoload,
      autoload = _options$autoload === void 0 ? true : _options$autoload,
      fields = _options.fields;
  return function (WrappedComponent) {
    var _class, _class2, _temp;

    var componentName = getDisplayName(WrappedComponent);
    var NAME = namespace || model.modelName;

    var WithEntityList = autobind(_class = (_temp = _class2 = /*#__PURE__*/function (_Component) {
      _inherits(WithEntityList, _Component);

      var _super = _createSuper(WithEntityList);

      function WithEntityList() {
        var _context;

        var _this;

        _classCallCheck(this, WithEntityList);

        _this = _super.call(this);

        _defineProperty(_assertThisInitialized(_this), "memPrepProps", _.memoize(_this.prepProps));

        _this.id = null;
        _this.args = {};
        _this.statusPromises = {};
        _this.consumerId = _concatInstanceProperty(_context = "".concat(componentName, "--")).call(_context, uuid());
        return _this;
      }

      _createClass(WithEntityList, [{
        key: "componentDidMount",
        value: function componentDidMount() {
          var _context2;

          if (!autoload) {
            // Don't do anything if autoload is disabled
            return;
          }

          this.args = this.getArgs(args, this.props);
          this.id = _.isFunction(id) ? id(this.props) : id;

          var list = _.get(this.props, '__state.list');

          if (!list || !_includesInstanceProperty(_context2 = [STATUS_LOADING, STATUS_LOADED]).call(_context2, list.status)) {
            // Fetch value list if not already in store
            this.props.__actions.fetchList({
              id: this.id,
              uuid: this.consumerId,
              args: this.args
            }).catch(function (e) {
              if (__DEV__) {
                console.error('Caught error in `withEntityList` initial load!');
                console.error(e);
              }
            });
          } else {
            this.props.__actions.registerListConsumer({
              id: this.id,
              uuid: this.consumerId
            });
          }
        } // eslint-disable-next-line babel/camelcase

      }, {
        key: "UNSAFE_componentWillReceiveProps",
        value: function UNSAFE_componentWillReceiveProps(nextProps) {
          var oldStatus = _.get(this.props, '__state.list.status');

          var newStatus = _.get(nextProps, '__state.list.status');

          if (oldStatus !== newStatus && this.statusPromises[newStatus]) {
            var _context3;

            _forEachInstanceProperty(_context3 = this.statusPromises[newStatus]).call(_context3, function (promise) {
              promise.resolve();
            });

            delete this.statusPromises;
          }

          if (!autoload) {
            // Don't do anything if autoload is disabled
            return;
          }

          this.id = _.isFunction(id) ? id(nextProps) : id; // Keep old args around for comparison

          var oldArgs = this.args;
          this.args = this.getArgs(args, nextProps);

          if (!_.isEqual(oldArgs, this.args)) {
            // Refetch list if arguments changed
            this.props.__actions.fetchList({
              id: this.id,
              uuid: this.consumerId,
              args: this.args
            });
          }
        }
      }, {
        key: "shouldComponentUpdate",
        value: function shouldComponentUpdate(nextProps) {
          if (_.isFunction(id)) {
            if (id(this.props) !== id(nextProps)) {
              return true;
            }
          }

          var oldArgs = this.getArgs(args, this.props);
          var newArgs = this.getArgs(args, nextProps);

          if (_Object$keys(oldArgs).length !== _Object$keys(newArgs).length) {
            return true;
          } // We want to shallow equal the args, since we will always get new references
          // if the args are a function or an object containing functions!
          // Ideally shallow args should usually contain strings or values that won't
          // have referencial integrity issues


          for (var key in oldArgs) {
            if (newArgs[key] === undefined || newArgs[key] !== oldArgs[key]) {
              return true;
            }
          } // Custom shallow equal here!


          for (var _key in nextProps) {
            var _context4;

            if (!_includesInstanceProperty(_context4 = ['__state', '__actions']).call(_context4, _key) && this.props[_key] !== nextProps[_key]) {
              return true;
            }
          }

          return this.props.__state.list !== nextProps.__state.list;
        }
      }, {
        key: "componentWillUnmount",
        value: function componentWillUnmount() {
          this.props.__actions.unregisterConsumer({
            id: this.id,
            uuid: this.consumerId
          });
        }
      }, {
        key: "getArgs",
        value: function getArgs(args, props) {
          var _this2 = this;

          if (_.isFunction(args)) {
            return args(props);
          }

          if (_.isObject(args)) {
            var _context5;

            return _reduceInstanceProperty(_context5 = _Object$keys(args)).call(_context5, function (all, key) {
              all[key] = _this2.getArgs(args[key], props);
              return all;
            }, {});
          }

          return args;
        }
      }, {
        key: "waitForStatus",
        value: function waitForStatus(status) {
          var _this3 = this;

          return new _Promise(function (resolve, reject) {
            if (_.get(_this3.props, '__state.list.status') === status) {
              resolve();
            } else {
              if (!_this3.statusPromises[status]) {
                _this3.statusPromises[status] = [];
              }

              _this3.statusPromises[status].push({
                resolve: resolve,
                reject: reject
              });
            }
          });
        }
      }, {
        key: "prepProps",
        value: function prepProps(props) {
          var _context6,
              _this4 = this;

          var coreProps = _objectSpread({}, props);

          delete coreProps.__state;
          delete coreProps.__actions;
          return _objectSpread(_objectSpread({}, coreProps), {}, _defineProperty({}, NAME, _objectSpread(_objectSpread(_objectSpread({}, props.__state), props.__actions), {}, {
            consumerUuid: this.consumerId,
            waitForStatus: this.waitForStatus,
            list: _objectSpread(_objectSpread({}, _.get(props, '__state.list', {})), {}, {
              // If fields are specified, only return requested fields!
              items: _mapInstanceProperty(_context6 = _.get(props, '__state.list.items', [])).call(_context6, function (item) {
                return fields ? filterDataToFields(item, fields) : item;
              }),
              // Ensure that list status is never undefined!
              status: _.get(props, '__state.list.status', autoload ? STATUS_LOADING : STATUS_IDLE)
            }),
            fetchList: function fetchList() {
              var args = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
              return props.__actions.fetchList({
                id: _this4.id,
                uuid: _this4.consumerId,
                args: _objectSpread(_objectSpread({}, _this4.args), args)
              });
            },
            fetchMore: function fetchMore() {
              var args = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
              return props.__actions.fetchPage({
                id: _this4.id,
                uuid: _this4.consumerId,
                page: _.get(props, '__state.list.pagination.currentPage', 0) + 1,
                args: _objectSpread(_objectSpread({}, _this4.args), args)
              });
            },
            refreshList: function refreshList() {
              return props.__actions.refreshList({
                id: _this4.id,
                uuid: _.get(props, '__state.list.consumers', [_this4.consumerId]),
                currentPage: _.get(props, '__state.list.pagination.currentPage'),
                args: _.get(props, '__state.list.args')
              });
            },
            fetchPage: function fetchPage(page) {
              var args = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
              return props.__actions.fetchPage({
                id: _this4.id,
                uuid: _this4.consumerId,
                page: page,
                args: _objectSpread(_objectSpread({}, _this4.args), args)
              });
            }
          })));
        }
      }, {
        key: "render",
        value: function render() {
          var prepProps = this.memPrepProps(this.props);
          return /*#__PURE__*/React.createElement(WrappedComponent, prepProps);
        }
      }]);

      return WithEntityList;
    }(Component), _defineProperty(_class2, "displayName", "withEntityList(".concat(componentName, ")")), _temp)) || _class;

    var mapStateToProps = function mapStateToProps(state, props) {
      var listId = _.isFunction(id) ? id(props) : id;
      return {
        __state: mapEntityListState(model, listId, state, props, fields)
      };
    };

    var mapDispatchToProps = function mapDispatchToProps(dispatch) {
      return {
        __actions: mapEntityDispatch(model, dispatch)
      };
    };

    return connect(mapStateToProps, mapDispatchToProps)(WithEntityList);
  };
}